import React from 'react';
import styled from 'styled-components';
import { IconActionChevronDown, IconActionChevronRight } from '@cko/icons';
import { useCollapsible, Box, ClickableElement } from '@cko/primitives';
const FullWidthButton = styled(ClickableElement) `
  font: var(--body-sm);
  padding: var(--layout-soybean) var(--layout-sandgrain);
  width: 100%;
  text-align: left;

  svg {
    float: left;
    margin-right: var(--layout-seed);
  }
`;
/**
 * @deprecated - This component is due to be deleted Please remove from your mfe.
 */
export const Accordion = ({ id, isOpen = false, open = React.createElement(IconActionChevronDown, null), close = React.createElement(IconActionChevronRight, null), title, onClick, children, showIcon = true, }) => {
    const { ref, styles } = useCollapsible({ isOpen });
    return (React.createElement(Box, { "aria-expanded": isOpen },
        React.createElement(FullWidthButton, { type: "button", "data-testid": "accordion-btn", id: id, "aria-controls": `control-${id}`, onClick: onClick },
            title,
            showIcon && (React.createElement("span", { "data-testid": isOpen ? 'accordion-icon-open' : 'accordion-icon-closed' }, isOpen ? open : close))),
        React.createElement("div", { "data-testid": "accordion-content", ref: ref, style: { ...styles }, "aria-labelledby": id }, children)));
};
